import { Context } from "@nuxt/types/app";

// for generating password
// https://stackoverflow.com/a/12635919/9433691
// eslint-disable-next-line no-extend-native
String.prototype.pick = function pickHandler(min: number, max?: number) {
  let n: number;
  let chars = "";

  if (typeof max === "undefined") {
    n = min;
  } else {
    n = min + Math.floor(Math.random() * (max - min));
  }

  for (let i = 0; i < n; i++) {
    chars += this.charAt(Math.floor(Math.random() * this.length));
  }

  return chars;
};

// for generating password
// https://stackoverflow.com/a/12635919/9433691
// Credit to @Christoph: http://stackoverflow.com/a/962890/464744
// eslint-disable-next-line no-extend-native
String.prototype.shuffle = function shuffleHandler() {
  const array = this.split("");
  let tmp: string;
  let current: number;
  let top = array.length;

  if (top) {
    while (--top) {
      current = Math.floor(Math.random() * (top + 1));
      tmp = array[current];
      array[current] = array[top];
      array[top] = tmp;
    }
  }

  return array.join("");
};

// https://stackoverflow.com/a/12635919/9433691
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function generatePassword(): string {
    // const specials = '!@#$%^&*()_+{}:"<>?|[];\',./`~';
    const specials = "!_@";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";

    const all: string = specials + lowercase + uppercase + numbers;

    let password = "";
    password += specials.pick(1);
    password += lowercase.pick(1);
    password += uppercase.pick(1);
    password += all.pick(5, 10);
    password = password.shuffle();

    return password;
  }

  return {
    generatePassword,
  };
}
